import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import React, { useEffect, useRef, useState } from "react"
import { Backdrop, Box, Button, Dialog, Modal, Paper, SxProps, Tooltip } from "@mui/material"
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { DeviceWidths } from "../../shared/src/types/Miscs"
import { useStore } from "../../contexts/store"
import { Op_editUserData } from "../../shared/src/types/Ops"
import getReactElementRef from '@mui/utils/getReactElementRef'
import Minibutton from "./Minibutton"

const HighlightBackdrop = ({rect}: {rect: any}) => {

  if (Date.now()>100) {

    if (Math.abs((rect.width/rect.height)-1) < .2) return <div>
      <div style={{position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: rect.y-5,
        left: rect.x-5,
        width: Math.max(rect.width, rect.height)+10,
        height: Math.max(rect.width, rect.height)+10,
        borderRadius:Math.max(rect.width, rect.height),
        boxShadow:'0 0 0 100000px rgba(0, 0, 0, 0.5)',
        backgroundColor: 'rgba(0, 0, 0, 0)'}}></div>
    </div>

    return <div>
    <div style={{position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: rect.y-5,
      left: rect.x-5,
      width: rect.width+10,
      height: rect.height+10,
      borderRadius:10,
      boxShadow:'0 0 0 100000px rgba(0, 0, 0, 0.5)',
      backgroundColor: 'rgba(0, 0, 0, 0)'}}></div>
  </div>

  }

  return <div>
    <div style={{position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: 0,
      left: 0,
      width: rect.x,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)'}}></div>
    <div style={{position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: 0,
      left: rect.right,
      right:0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)'}}></div>
    <div style={{position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: 0,
      height: rect.y,
      left: rect.x,
      width:rect.width,
      backgroundColor: 'rgba(0, 0, 0, 0.5)'}}></div>
    <div style={{position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: rect.bottom,
      bottom: 0,
      left: rect.x,
      width:rect.width,
      backgroundColor: 'rgba(0, 0, 0, 0.5)'}}></div>
  </div>
}

// selected text associated with the interaction
const Clicktip = ({id, variant='popup', width=null, height=null, placement, deviceWidth=null, modal=false, showAfter=null, delay=0, showAsTooltip=false, children=null, sx=null}: {
  id: string,
  variant?: 'popup'|'box'|'tooltip',
  width?: null|number,
  height?: null|number,
  placement?: 'top-start'|'top'|'top-end'|'right-start'|'right'|'right-end'|'bottom-end'|'bottom'|'bottom-start'|'left-end'|'left'|'left-start',
  deviceWidth?: null|DeviceWidths,
  showAfter?: null|number,
  delay?: number,
  showAsTooltip?: boolean,
  modal?:any,
  children?: any,
  sx?:SxProps|null,
}) => {
  const { clicktipStore, opStore, sessionStore } = useStore()
  const clicktip = clicktipStore.clicktips
  const [ rect, setRect ] = useState('{}')

  const session = sessionStore.session
  if (!session) return children || null

  const number = clicktipStore.clicktips.findIndex(c => c.id === id)
  if (number<0) return children || null

  const tip = clicktipStore.clicktips[number]
  const content = clicktip[number].content


  var showAfterFulfilled = true
  if (tip.showAfter) {
    const showAfterRef = clicktipStore.clicktips.findIndex(c => c.id === tip.showAfter)
    if (showAfterRef>-1) {
      const showAfterShown = clicktipStore.clicktips[showAfterRef].seen || (session.user.seenClicktips && session.user.seenClicktips.indexOf(showAfterRef) > -1)
      if (!showAfterShown) showAfterFulfilled = false
    }
    else {
      console.warn(`Could not find preconditional showAfter clicktip "${tip.showAfter}"`)
    }
  }

  const closed = (
       clicktip[number].seen ||
       (Number(session.user.seenClicktips?.indexOf(number)) >= 0) ||
       (!showAfterFulfilled)
  )

  const close = () => {
    clicktipStore.setSeen(number, true)
  }

  const dontShowAgain = () => {
    const seenClicktips = session.user.seenClicktips || []
    const newSeenClicktips = seenClicktips.filter(a => a!==number)
    newSeenClicktips.push(number)
    const op:Op_editUserData = {
      op:'editUserData',
      podId:null,
      data: {
        userId: session.user.userId,
        userName: null,
        usergroupId: '*private',
        mods: {
          seenClicktips: newSeenClicktips,
        }
      }
    }
    opStore.doOp(op)
  }

  const tooltipStyle = {
    backgroundColor:'#fffc',
    color:'rgba(0, 0, 0, 0.87)',
    boxShadow: '0 0 8px 4px #0004',
  }

  switch(variant) {

      case 'tooltip':
        if (children === null) return <div>Clicktip invalid: Variant tooltip must have children</div>
        if (closed) return children

        return <>
        <Tooltip arrow slotProps={{tooltip:{sx: tooltipStyle}, arrow: {sx: { color:'#fffc' }}}} ref={ (element: null|HTMLElement) => { if (element) { const newRect = JSON.stringify(element.getBoundingClientRect()); if (newRect !== rect) setRect(newRect) } }} open={!closed} title={<React.Fragment>
            <Box sx={{p:1}}>
            {content}
            <div style={{marginTop:10, borderTop:'1px solid #0004', paddingTop:8, textAlign:'right'}}>
              <Minibutton onClick={close}>Ok</Minibutton> <Minibutton onClick={dontShowAgain}>Don't show again</Minibutton>
            </div>
            </Box>
          </React.Fragment>}>
            {children}
        </Tooltip>
        <Backdrop open={Boolean(modal)} onClick={close} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} invisible children={<HighlightBackdrop rect={JSON.parse(rect)} />} />
        </>

      case 'box':
        if (children !== null) return <div>Clicktip invalid: Variant box must not have children</div>
        if (closed) return null
        return <Paper sx={{p:1, position:'relative', ...sx}}>
          {content}
          <div style={{position:'absolute',right:10, paddingTop:8, marginTop:10, bottom:10}}><Minibutton onClick={close}>Ok</Minibutton> <Minibutton onClick={dontShowAgain}>Don't show again</Minibutton></div>
        </Paper>

      case 'popup':
        if (children !== null) return <div>Clicktip invalid: Variant box must not have children</div>
        const style = {
          p:1
        }

        return <Dialog
          open={!closed}
          onClose={close}
        >
        <Box sx={style}>
          {content}
          <div style={{textAlign:'right', borderTop:'1px solid #0004', paddingTop:8, marginTop:10}}><Minibutton onClick={close}>Ok</Minibutton> <Minibutton onClick={dontShowAgain}>Don't show again</Minibutton></div>
        </Box>
      </Dialog>
  }

}

export default observer(Clicktip)
